export default "__VITE_ASSET__b654e4c7__"